
import ReservierungVorbestellungLogic from "@/logic/bestellung_neu/reservierung_vorbestellung_logic"
import Component, { mixins } from "vue-class-component"
import ReservierungVorbestellung from "@/components/bestellung-neu/ReservierungVorbestellung.vue"
import ArtikelRow from "../custom/ArtikelRow.vue"
import FilialeHeader from "../custom/FilialeHeader.vue"
import Calculator from "../mixins/Calculator.vue"
import { BstlArtikel, LoadState } from "mangdto"
import ArtikelEdit from "../custom/ArtikelEdit.vue"
import WarenkorbArtikel from "./sub/WarenkorbArtikel.vue"

@Component({
  components: {
    ArtikelRow,
    FilialeHeader,
    ArtikelEdit,
    WarenkorbArtikel,
  },
})
export default class ReservierungVorbestellungBestaetigen extends mixins(
  Calculator,
) {
  logic?: ReservierungVorbestellungLogic = null

  LoadState = LoadState

  mounted() {
    this.logic = (this.$parent as ReservierungVorbestellung).logic
    this.logic.reservierungId = this.$route.params.reservierungId
  }

  geheZurBestellung() {
    this.logic.geheZurBestellung()
  }

  bestellungBestaetigen() {
    this.logic.bestellungBestaetigen()
  }

  increment(artikel: BstlArtikel) {
    this.logic.increment(artikel)
  }

  decrement(artikel: BstlArtikel) {
    this.logic.decrement(artikel)
  }

  remove(artikel: BstlArtikel) {
    this.logic.remove(artikel)
  }
}
